import ThaiBahtText from "thai-baht-text";
import BootstrapTable from "react-bootstrap-table-next";
import filterFactory, { textFilter } from "react-bootstrap-table2-filter";
import paginationFactory from "react-bootstrap-table2-paginator";

import styled from "styled-components";
import { Button, Form, FormControl, InputGroup, Modal } from "react-bootstrap";
import {
  AiFillDelete,
  AiFillEdit,
  AiFillPrinter,
  AiOutlineClose,
} from "react-icons/ai";
import { BsGear, BsPlus } from "react-icons/bs";
import { MdClose, MdRefresh } from "react-icons/md";

import {
  LabelGrey,
  ModalBodyBlack,
  ModalFooterBlack,
  ModalHeaderBlack,
  MyModal,
} from "../features/RadConnStyle";
import { Oval } from "react-loading-icons";
import { BiSave } from "react-icons/bi";

import { useEffect } from "react";
import { PageOptions } from "../pages/components/PageParams";
import { ConfirmDefault } from "../pages/components/ConfirmDialogB";
import {
  CreateTooltip,
  DeepMergeObject,
  DotStringToObject,
  GetThaiZoneDate,
  toDecimal,
} from "./Helper";
export const GetCreateTable = (props) => {
  const {
    idFieldName,
    columns,
    data,
    rowEvents,
    selectRow,
    ref,
    defaultSorted,
    wrapperClasses,
    pageOptionProps,
    disablePagintaion,
  } = props;

  return (
    <BootstrapTable
      bootstrap4
      keyField={idFieldName ?? "id"}
      data={data && data}
      columns={columns}
      // striped
      hover
      condensed
      rowClasses="table-next-rows-style"
      headerWrapperClasses="headerWrapper"
      wrapperClasses={wrapperClasses ?? "table-wrapper"}
      bordered={true}
      pagination={
        disablePagintaion
          ? null
          : paginationFactory(GetPageOptions(pageOptionProps ?? {}))
      }
      filter={filterFactory()}
      rowEvents={rowEvents}
      selectRow={selectRow}
      defaultSorted={defaultSorted ?? {}}
      ref={ref}
      {...props}
    />
  );
};

const EditBoxButton = styled(Button)`
  margin-inline: 2px;
  padding-left: 2px;
  padding-right: 2px;
  padding-top: 2px;
  padding-bottom: 2px;
  width: 30px;
  height: 30px;
`;

const EditBox = styled.div`
  display: flex;
  flex: 1;
  justify-content: end;
`;

// ** type of control object
export const FormControlType = {
  TEXT: 1,
  PASSWORD: 2,
  SELECT: 3,
  LABEL: 4,
  TEXT_AREA: 5,
  SEARCHER: 6,
  DATE_PICKER: 7,
  CHECK_BOX: 8,
  HIDDEN: 9,
  DECIMAL: 10,
  NUMERIC: 11,
  FORMATTED_TEXT: 12,
  DECIMAL_LOCK_VALUE: 13,
  DATETIME_PICKER: 14,
};

// Data type of field.
export const FieldDataType = {
  TEXT: 1,
  NUMERIC: 2,
  BOOLEAN: 3,
  DATE: 4,
};

export const FormatEditBox = (x, row, OnEditClick, onRemoveClick) => {
  return (
    <EditBox>
      {OnEditClick ? (
        CreateTooltip(
          "Edit",
          <EditBoxButton variant="success" onClick={() => OnEditClick(x, row)}>
            <AiFillEdit size={20} />
          </EditBoxButton>,
          "left",
        )
      ) : (
        <></>
      )}
      {onRemoveClick ? (
        CreateTooltip(
          "Remove",
          <EditBoxButton variant="danger" onClick={() => onRemoveClick(x, row)}>
            <AiFillDelete />
          </EditBoxButton>,
          "left",
        )
      ) : (
        <></>
      )}
    </EditBox>
  );
};

export const KeyCode = {
  ENTER: 13,
  ESC: 27,
  BACKSPACE: 8,
  DEL: 46,
  SPACEBAR: 32,
};

export const SearchBox = (props) => {
  const [text, setText] = props.text;
  const { onResetClick } = props;
  // const [dateRangeValues, changeDateRange] = useState([new Date(), new Date()]); // props.dateRange;
  return (
    <div>
      {/* <DateRangePicker
        onChange={changeDateRange}
        value={dateRangeValues}
        format="dd/MM/yyyy"
        locale="th-Th"
        closeCalendar={false}
        clearIcon={null}
      /> */}
      <InputGroup>
        <FormControl
          className="search-box-text"
          type="text"
          autoComplete="off"
          key="s1"
          placeholder="ค้นหา..."
          {...props}
          ref={props?.refTo}
          value={text}
          onChange={(e) => setText(e.target.value)}
        />
        <Button onClick={onResetClick}>
          <MdRefresh color="var(--page-total-text-color)" />
        </Button>
        <Button onClick={(e) => setText("")}>
          <MdClose color="var(--page-total-text-color)" />
        </Button>
      </InputGroup>
    </div>
  );
};

export const getDecimalString = (value, digits) => {
  if (!value) value = "0";
  value = value.toString().replace(/[,]/g, "");
  if (!value || isNaN(Number(value))) {
    return "0.00";
  } else {
    return toDecimal(value, digits ?? 2);
  }
};
export const getCommalessNumber = (value) => {
  return Number(value?.toString().replace(/[,]/g, "") ?? 0);
};
export const getIntegerString = (value) => {
  value = value.toString().replace(/[,]/g, "");
  if (!value || isNaN(Number(value))) {
    return "0";
  } else {
    return toDecimal(value, 0);
  }
};

/** แปลงจาก 'object_id' => 'objectId' */
export const FieldName2Upper = (fieldName) => {
  return fieldName.replace(/_[a-z]/g, (v) => {
    return v.substring(v.length - 1).toLocaleUpperCase();
  });
};

export const FieldName2Lower = (fieldName) => {
  let tx1 = fieldName.substring(0, 1);
  let txRm = fieldName.substring(1);

  let ret = txRm.replace(/[A-Z]/g, (v) => {
    return "_" + v.toLocaleLowerCase();
  });

  return tx1.replace(/[A-Z]/g, (v) => v.toLocaleLowerCase()) + ret;
};

export const LabelTextGrey = (props) => {
  return <LabelGrey {...props} />;
};

export const DefaultBillViewer = {
  show: false,
  action: () => {},
  document: null,
};

export const DefaultEditorValue = { show: false, action: () => {} };

export const ShowsEditor = (
  objEditor,
  idFieldName,
  idFieldValue,
  callbackAction,
  onAddNew,
  data,
  readOnly,
) => {
  objEditor((pv) => ({
    ...pv,
    show: true,
    idFieldName: idFieldName,
    idValue: idFieldValue,
    action: callbackAction,
    onAddNew: onAddNew,
    data: data,
    readOnly: readOnly ?? false,
  }));
};

export const ConfirmsDeleteAction = (setObject, okCallback, title) => {
  setObject((pv) => ({
    ...pv,
    show: true,
    title: title,
    action: async (ok) => {
      if (ok) {
        okCallback();
      } else {
        setObject(ConfirmDefault);
      }
    },
  }));
};

export const GetEditorForm = (props) => {
  const [editor, setEditor] = props.editor;
  const [form, setForm] = props.form;
  const {
    saveData,
    print,
    title,
    size,
    comment,
    otherButtons,
    saveButtonTitle,
    fullscreen,
    footerLeft,
  } = props;

  useEffect(() => {
    return () => {
      // console.log("xxxx");
    };
  }, [editor]);

  const onHide = () => {
    setEditor((pv) => {
      return { ...pv, show: false };
    });
  };

  return (
    <MyModal
      size={size ?? "lg"}
      show={editor?.show}
      backdrop={false}
      centered
      // style={{ background: "black" }}
      fullscreen={fullscreen ?? false}
      // onHide={onHide}
    >
      <ModalHeaderBlack backdrop={false} closeButton onHide={onHide}>
        <DivTitle>
          <BsGear
            color="var(--icon-fore)"
            style={{ marginInlineEnd: "10px" }}
          />
          <span style={{ color: "var(--caption-fore-color2)" }}>{title}</span>
        </DivTitle>
      </ModalHeaderBlack>
      <ModalBodyBlack style={{ color: "var(--x-fore-primary)" }}>
        {comment}
        {form}
      </ModalBodyBlack>
      <ModalFooterBlack>
        <div
          style={{
            display: "flex",

            justifyContent: "space-between",
            width: "100%",
          }}
        >
          <span>{footerLeft}</span>
          <span style={{ display: "flex" }}>
            {saveData ? (
              <EditFormButton onClick={(e) => saveData && saveData()}>
                {editor?.wait ? (
                  <Oval size={15} />
                ) : (
                  <BiSave color="#00ff00" size={30} />
                )}
                {saveButtonTitle ?? "บันทึก"}
              </EditFormButton>
            ) : (
              <></>
            )}

            {otherButtons}

            {print ? (
              <EditFormButton
                hidden={print?.hidden ?? true}
                disabled={print?.disabled ?? false}
                onClick={(e) => print && print.action()}
              >
                <AiFillPrinter color="#00ff00" size={30} /> พิมพ์
              </EditFormButton>
            ) : (
              <></>
            )}
            <EditFormButton variant="danger" onClick={() => onHide()}>
              <AiOutlineClose size={30} />
              กลับ
            </EditFormButton>
          </span>
        </div>
      </ModalFooterBlack>
    </MyModal>
  );
};

const EditFormButton = styled(Button)`
  margin-inline: 5px;
`;

export const GetListForm = (props) => {
  const [editor, setEditor] = props.list;
  const { title, size, children, fullscreen, otherButtons, icon } = props;

  const onHide = () => {
    setEditor((pv) => {
      return { ...pv, show: false };
    });
  };
  return (
    <MyModal
      size={size ?? "xl"}
      show={editor?.show}
      // backdrop
      centered
      fullscreen={fullscreen ?? false}
    >
      <ModalHeaderBlack closeButton onHide={onHide}>
        <DivTitle>
          {icon ?? (
            <BsGear
              color="var(--icon-fore)"
              style={{ marginInlineEnd: "10px" }}
            />
          )}
          <span style={{ color: "var(--caption-fore-color2)" }}>{title}</span>
        </DivTitle>
      </ModalHeaderBlack>
      <ModalBodyBlack style={{ color: "var(--x-fore-primary)" }}>
        {children}
      </ModalBodyBlack>
      <ModalFooterBlack>
        {otherButtons}
        <Button variant="danger" onClick={() => onHide()}>
          กลับ
        </Button>
      </ModalFooterBlack>
    </MyModal>
  );
};

const DivTitle = styled.div`
  color: var(--tb-fore-header);
`;

export const GetPatientAge = (strAge) => {
  if (!strAge) return " ไม่ระบุ ";
  return strAge
    .replace(/^0+/g, "")
    .replace(/[y,Y]/g, " ปี")
    .replace(/[m,M]/, " เดือน");
};

export const GetPatientSex = (strSex) => {
  if (!strSex) return "ไม่ระบุเพศ";
  // return strSex.toString().toLocaleUpperCase === "M" ? "ชาย" : "หญิง";
  return strSex.toString().toLocaleUpperCase() === "M" ? "ชาย" : "หญิง";
};

export const GetThaiBahtString = (amount) => {
  if (amount === null || amount === undefined) return "";
  return "(" + ThaiBahtText(amount) + ")";
};

export const FormCancleClick = (item, setObject) => {
  if (!setObject) return;
  setObject((pv) => ({
    ...pv,
    ...DeepMergeObject(
      DotStringToObject(item.fieldName + "." + item.searchValueName, 0),
      DotStringToObject(item.fieldName + "." + item.searchDisplayName, null),
    ),
  }));
};

export const GetPageOptions = (props) => ({
  ...{
    page: 1,
    sizePerPage: 25,
    lastPageText: ">>",
    firstPageText: "<<",
    nextPageText: ">",
    prePageText: "<",
    showTotal: true,
    alwaysShowAllBtns: false,
    paginationTotalRenderer: (from, to, size) =>
      !props?.hideSizePerPage ? (
        <span className="page-total-item">
          {/* Showing {from} to {to} of {size} Results */}
          {size > 0 ? (
            <span>
              {getTextSpan("(")}
              {from}
              {getTextSpan("-")}
              {to}
              {getTextSpan(") ")}
              {getTextSpan(" จาก ")} {getDecimalString(size, 0)}
            </span>
          ) : (
            <></>
          )}
        </span>
      ) : (
        <span style={{ color: "var(--fore-secondary)" }}>
          {" "}
          {getGreenSpan(size)} รายการ
        </span>
      ),
  },
  ...props,
});

const getGreenSpan = (text) => (
  <span style={{ color: "var(--page-total-text-color)" }}>{text}</span>
);
const getTextSpan = (text) => <span style={{ color: "#474545" }}>{text}</span>;
